export enum Incoterms {
  EXW = "EXW",
  FCA = "FCA",
  FAS = "FAS",
  FOB = "FOB",
  CFR = "CFR",
  CIF = "CIF",
  CPT = "CPT",
  CIP = "CIP",
  DPU = "DPU",
  DAP = "DAP",
  DDP = "DDP",
  UK_SOURCED_BRAND = "UK_SOURCED_BRAND",
  DE_SOURCED_BRAND = "DE_SOURCED_BRAND"
}
